const mutations = {
  SET_PERMISSION_LEVEL(state, { permissionLevel }) {
    state.permissionLevel = permissionLevel
  },
}

export default mutations
